import React from "react";

import { Lending } from "../../components/Lending";

export const LendingMonsPius = () => {
  return  <Lending title="Mons Pius"/>
};
